export const SET_SERACHVAL = "SET_SERACHVAL";
export const SET_CAMPAIGN_ID = "SET_CAMPAIGN_ID";
